/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
export const useOnClickOutside = (refs, handler) => {
    React.useEffect(() => {
        const handleClick = (event) => {
            const isInside = refs.some(elRef => {
                const el = elRef.current;
                if (el === event.target || (el === null || el === void 0 ? void 0 : el.contains(event.target))) {
                    return true;
                }
                else {
                    return false;
                }
            });
            if (isInside)
                return;
            handler(event);
        };
        // Using events that happen before click to handle cases when element is hidden on click
        document.addEventListener('pointerdown', handleClick);
        return () => {
            document.removeEventListener('pointerdown', handleClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [handler, ...refs]);
};
